(function () {
    angular
        .module('editor-menu.dir', [])
        .directive('editorMenu', ['$rootScope', editorMenu]);

    function editorMenu($rootScope) {
        return {
            scope: {
                isActiveEmail: '=',
                connections: '='
            },
            templateUrl: function(elem, attrs) {
                return attrs.templateUrl || 'app/views/templates/editor-menu.tpl.html'
            },
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                // Default value for editor
                $scope.editor = 'dad';

                $scope.redirectTo = function(id) {
                    if ($scope.isActiveEmail) {
                        $rootScope.$emit('activeRedirectTo', id);
                    } else {
                        $rootScope.$emit('redirectToEditor', id);
                    }

                    $scope.$parent.editorSubMenu = false;
                };

                $scope.switcher = (editor) => {
                    $scope.editor = editor;
                };

                $scope.hideModal = () => {
                    $rootScope.editorSubMenu = false;
                    $rootScope.$emit('hideEditorModal', $scope.connections);
                };

                $scope.upsellTracking = ($event) => {
                    if ($event.target.matches('a')) {
                        const eventName = 'code editor upsell - link';
                        if (typeof FS != 'undefined') {
                            FS.event(eventName);
                        }
                        Intercom('trackEvent', eventName);
                    }
                };

            }],
            link: function (scope, elem) {
                scope.endJourney = function () {
                    scope.$parent.displaySubMenu = false;
                };
            }

        }

    }

}());



// WEBPACK FOOTER //
// ./app/directives/canvas_directives/editor-menu.js